import Reflux from 'reflux';

const LeadActions = Reflux.createActions(['loadLead', 'saveLead']);

export default LeadActions;



// WEBPACK FOOTER //
// ./app/assets/javascripts/actions/leadActions.jsx